import {useEffect, useState} from 'react';
import Loader from './Loader';
import { csv2json } from '../../util/LandmarksUtils';
const csv = require('jquery-csv')

class CSVLoader extends Loader {
    constructor() {
        super()
    }

    handleSubmission = ()=> {
        try{
            const fileReader = new FileReader()
            fileReader.readAsText(this.state.selectedFile,'UTF-8')
            console.log(fileReader)
            fileReader.onload=(event)=>{
                const csv_content = csv.toObjects(event.target?.result,{separator:';'})
                let json_content =  csv2json(csv_content,this.state.normalizePoints)
                this.setState({...this.state,fileContentJson:json_content},()=>{
                    this.props.onSubmitFile()
                })
            }
        }
        catch(error){
            //
        }
	}

    handleLoadLink = async (event,isValue)=>{
        let link = isValue ? event : event?.target?.value
        let jsonResult
        if(event?.keyCode === 13 || isValue){
            try{
                let csv_result = await fetch(link,
                    {
                        headers : { 
                            'Content-Type': 'application/csv',
                            'Accept': 'application/csv'
                        }
                    })
                    .then(function(response){
                        return response.text();
                    })
                    .then((myCSV)=>{
                        return myCSV
                    })
                    jsonResult = csv2json(csv.toObjects(csv_result),this.normalizePoints)
                    this.setState({...this.state,fileContentJson:jsonResult},()=>{
                        this.props.onSubmitFile()
                    })
            }
            catch(e){

            }
            console.log(jsonResult)
        }
    }

    render(){
        return this.renderParent()
    }

}

export default CSVLoader
